export const ROLE_LIST = [{ value: 'Admin', label: 'Admin' }]

export const NFC_ROLE_LIST = [
  { value: 'NFC Admin', label: 'NFC Admin' },
  { value: 'CLC FULL Operator', label: 'CLC FULL Operator' },
  { value: 'CLC NDDC Operator', label: 'CLC NDDC Operator' }
]

export const RFID_ROLE_LIST = [
  { value: 'RFID Admin', label: 'RFID Admin' },
  { value: 'RFID NSP Store User', label: 'RFID NSP Store User' },
  { value: 'RFID MPO', label: 'RFID MPO' }
]
export const YN_LIST = [
  { value: 2, label: 'N' },
  { value: 1, label: 'Y' }
]
